module.exports = __webpack_public_path__ + "static/img/banner_new02.60d0a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUs/banner_new02.png
// module id = QSOf
// module chunks = 1